/**
 * Created by r4zi4l on 13.05.2021
 */

const BuildPassWindow = CleverappsWindow.extend({ 
    onWindowLoaded: function (mission) {
        this.mission = mission;

        const components = [{
            name: "header",
            class: PassHeader,
            params: {
                bg_json: bundles.pass.jsons.bg_json,
                pack_json: bundles.pass.jsons.pack_json,
                decor_json: bundles.pass.jsons.decor_json,
                close: this.close.bind(this),
                passLogic: mission.logic
            }
        }, {
            name: "progress",
            class: PassProgress
        }, {
            name: "tickets",
            class: PassTickets
        }];

        this._super({
            name: "BuildPassWindow",
            title: Messages.get("BuildPassWindow.title"),
            content: new PassWindowContent({
                components,
                width: cleverapps.styles.BuildPassWindow.width,
                styles: cleverapps.styles.BuildPassWindow,
                passLogic: mission.logic
            }),
            help: () => {
                cleverapps.focusManager.display({
                    focus: "BuildPassGuideWindow",
                    stack: true,
                    action: (f) => {
                        new GuideWindow(mission.guideWindow);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            },
            foreground: bundles.passforeground.frames.pass_window_foreground_png,
            contentPadding: cleverapps.styles.BuildPassWindow.contentPadding,
            closeButton: true,
            noPadding: true,
            styles: cleverapps.styles.BuildPassWindow.window
        });
    },

    onShow: function () {
        this._super();
        this.mission.logic.handleShowWindow();
    },

    listBundles: function () {
        return ["pass"];
    }
});

cleverapps.styles.BuildPassWindow = {
    width: 1756,
    height: 872,
    paddingX: 50,

    window: {
        Foreground: {
            contentPadding: {
                top: 300
            }
        }
    },

    contentPadding: {
        right: 40
    },

    header: {
        x: { align: "center", dx: -3 },
        y: { align: "top", dy: 1 }
    },

    progress: {
        x: { align: "right", dx: 2 },
        y: { align: "center", dy: -122 }
    },

    tickets: {
        x: { align: "left", dx: -2 },
        y: { align: "center", dy: -118 }
    }
};
